import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from '../../shared/providers/toast.service';
import { PropertyImportService } from '../../shared/providers/property-import.service';
import { IImportPropertyOutput } from '../../shared/models/importPropertyOutput';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { environment } from '../../../environments/environment'

@Component({
    selector: 'property-import',
    templateUrl: './property-import-component.html',

})

export class ImportPropertyComponent implements OnInit {

    importPropertyResponse = {} as IImportPropertyOutput;
    resultOutputModel = {} as ResultOutputModel;
    errors: Array<string> = [];
    canShow1031Template = false;
    stage = 0;
    fileDocExt: string = "xlsx";
    maxFiles: number = 5;
    maxSize: number = 5; // 5MB
    clearFilescounter: number = 0;
    uploadType: string;
    extensionType: string = "document";
    selectFiles: string[] = [];
    fileName = "";
    loggedUserDetails: any;
    @ViewChild('file') fileInput: ElementRef;
    excelDownloadPath = environment.importExcelPath;
    constructor(private _toastService: ToastService, private _propertyImportService: PropertyImportService,
        private authService: AuthenticationService, public Validation: ValidationService) { }

    ngOnInit() {
        this.authService.isLoggedIn.subscribe(response => {
            if (response) {
                this.loggedUserDetails = this.authService.user;
            }
        });
    }

    onTemplateChange(val) {
        this.canShow1031Template = val;
    }
    reValidateClick() {
        this.stage = 3;
    }
    onValidateClick() {
        
        this.stage = 4;

        if (this.selectFiles.length > 0) {

            const frmData = new FormData();
            frmData.append("templateType", this.canShow1031Template == true ? "1031 Listing" : "B+E Listing");

            for (var i = 0; i < this.selectFiles.length; i++) {
                frmData.append("fileUpload", this.selectFiles[i]);
            }

            this._propertyImportService.validateProperty(frmData).subscribe(response => {
                this.importPropertyResponse = response;
                if (this.importPropertyResponse.IsSuccess) {
                    this.stage = 3;
                }
                else {
                    this.stage = 2;
                }
            });

        }
        else {
            this.stage = 0;
            if (!this.canShow1031Template) {
                this._toastService.addToast({ title: 'Error Occurred', msg: "Please upload a B+E Listing template", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
            else {
                this._toastService.addToast({ title: 'Error Occurred', msg: "Please upload a 1031 Listing template", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
        }
    }

    onImportClick() {
        this.stage = 1;
        this.importPropertyResponse.LoginUserId = this.loggedUserDetails.Id;
        this._propertyImportService.importProperty(this.importPropertyResponse).subscribe(response => {
            this.resultOutputModel = response;
            if (this.resultOutputModel.Success) {
                this.stage = 0;
                this.fileName = "";
                this.fileInput.nativeElement.value = "";
                this._toastService.addToast({ title: 'Success', msg: 'Upload Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
            }
            else {
                this.stage = 0;
                this._toastService.addToast({
                    title: 'Error Occurred while saving imported data.', msg: '', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
                })
            }
        });


    }

    onFileChange(event: any) {

        this.addToFilesArray(event);
    }
    // File upload control Events -Start
    addToFilesArray(event: any) {
        
        let files = event.target.files;
        let IsValidFile = true;

        this.fileName = files[0].name;
        this.selectFiles = [];
        // Validate file size and allowed extensions
        if (!this.IsvalidateFile(files)) {

            IsValidFile = false;
        }
        if (IsValidFile) {
            for (var i = 0; i < event.target.files.length; i++) {
                this.selectFiles.push(event.target.files[i]);
            }
        }
    }


    private isValidFiles(files: any) {

        this.isValidFileExtension(files);
        return this.errors.length === 0;
    }

    private isValidFileExtension(files: any) {

        var extenstionType = this.extensionType;
        var extensions;
        // Make array of file extensions
        if (extenstionType == "document") {
            extensions = (this.fileDocExt.split(','))
                .map(function (x) { return x.toLocaleUpperCase().trim() });
        }

        for (var i = 0; i < files.length; i++) {
            // Get file extension
            var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
            // Check the extension exists
            var exists = extensions.indexOf(ext);
            if (exists < 0) {
                this.errors.push("Error (Extension): " + files[i].name);
            }
            // Check file size
            this.isValidFileSize(files[i]);
        }
    }

    private isValidFileSize(file: any) {
        var fileSizeinMB = file.size / (1024 * 1000);
        var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
        if (size > this.maxSize)
            this.errors.push("Error (File Size): " + file.name + ": exceed file size limit of " + this.maxSize + "MB ( " + size + "MB )");
    }

    IsvalidateFile(File: any) {

        this.errors = []; // Clear error
        if (File.length > 0 && (!this.isValidFiles(File))) {
            return false;
        }
        else {
            return true;
        }
    }


}
